<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
      <b-col lg="6">
        <!--Display Trash or Normal Table View-->
        <h2>Roles</h2>
			</b-col>
    </div>
		<div class="card">
		    <div class="card-body">
			    <b-row>
		        	<b-container fluid roles>
								<div class="row">

									<b-col lg="6" md="6" xs="12" class="my-1">
										<div class="input-group mb-3">
											<div class="input-group-prepend">
												<b-form-input v-model="filter" placeholder="Search" />
												<b-btn class="brad-0" :disabled="!filter" @click="filter = ''">Clear</b-btn>
											</div>
										</div>
									</b-col>

									<b-col lg="6" md="6" xs="12">
										<b-button @click="showNewLocationModal" variant="primary" class="active mb-3 pull-right">Add Role</b-button>
									</b-col>
								</div>
		        			<b-row v-if="loadingData">
			              <b-col cols="12" sm="12" md="12" lg="12">
			                 <p class="text-center">
			                   <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
			                 </p>
			              </b-col>
			            </b-row>
									<b-table 	class="animated fadeIn" striped hover v-else bordered show-empty
													stacked="md"
													:items="items"
													:fields="fields"
													:current-page="currentPage"
													:per-page="perPage"
													:filter="filter"
													:sort-by.sync="sortBy"
													:sort-desc.sync="sortDesc"
													@filtered="onFiltered"
													@row-clicked="rowClicked">
            			</b-table>
	<!--		            <b-table class="animated fadeIn" v-else striped hover bordered 			show-empty
                     		stacked="md"
                     		:items="items"
                     		:fields="fields"
                     		:current-page="currentPage"
                     		:per-page="perPage"
                     		:filter="filter"
                     		:sort-by.sync="sortBy"
                     		:sort-desc.sync="sortDesc"
                     		@filtered="onFiltered"
            			>
            				<template slot="id" slot-scope="row"><div  @click="$router.push('/role/'+row.item.id)">{{row.value}}</div></template>
            				<template slot="name" slot-scope="row"><div  @click="$router.push('/role/'+row.item.id)">{{row.value}}</div></template>
				            <template slot="row-details" slot-scope="row">
				                <b-card>
				                    <ul>
				                      <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
				                    </ul>
				                </b-card>
				            </template>
            			</b-table>		-->
            			<!-- User Interface controls -->
									<b-row>
										<b-col lg="2" md="2" sm="12" class="my-1 pull-left">
											<div class="input-group mb-3">
												<div class="input-group-prepend"> </div>
												<b-select :options="pageOptions" v-model="perPage" />
											</div>
										</b-col>
										<b-col lg="10" md="10" sm="12" class="my-1 pull-right">
											<b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
										</b-col>
									</b-row>
					</b-container>
				</b-row>
		    </div>
		</div>
		    <!-- New EModal-->
    <b-modal title="New Role" ref="newLocationModal" v-model="newLocations" hide-header-close no-close-on-backdrop no-close-on-esc>
      <b-row>
        <b-col cols="12">
              <b-form-group id="L1" label="Role Name" label-for="rolename" horizontal>
                <b-form-input id="rolename" type="text" v-model="model.name" placeholder="Enter Role Name" >
                </b-form-input>
              </b-form-group>
        </b-col>
      </b-row>
			<div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="hideNewLocationModal" class="float-left">Cancel</b-btn>
        <b-btn :disabled="savebtn" size="md" variant="primary" @click="saveLocations" class="float-right">Save</b-btn>
      </div>
    </b-modal>
	</div>
</template>

<script>

	import Vue from 'vue'
	import roles_service from './roles_service'

	const items = []
	export default {
		name: 'm_roles',
		created: function () {
				this.getAll()
				localStorage.removeItem("targetsaPage");
				localStorage.removeItem("ftPage");
				localStorage.removeItem("targetPage");
				localStorage.removeItem("tpPage");
				localStorage.removeItem("oasaPage");
				localStorage.removeItem("oaPage");
				localStorage.removeItem("reportPage");
				localStorage.removeItem("tasaPage");
				localStorage.removeItem("servicePage");
				localStorage.removeItem("taPage");
				localStorage.removeItem("tcPage");
				localStorage.removeItem("locationPage");
	      localStorage.removeItem("truckPage");
	      localStorage.removeItem("userPage");
	      if (!localStorage.rolesPage) {
	          localStorage.rolesPage = 0;
	      }
	    },
		data () {
			return {
				newLocations: false,
				items: items,
				loadingData: true,
				currentPage: parseInt(localStorage.rolesPage),
		    perPage: 25,
		    totalRows: items.length,
		    pageOptions: [ 25, 50, 100],
		    sortBy: null,
		    sortDesc: false,
		    fields: [
					{ key: 'id', label: 'Id', sortable: true },
					{ key: 'name', label: 'Role Name', sortable: true}
		    ],
		    filter: null,
		    modalInfo: { title: '', content: '' },
		    configTable: false,
				model:{
						id : null,
						name : '',
				},
				savebtn:true
		}
	},
		computed: {
	      sortOptions () {
	        // Create an options list from our fields
	        return this.fieldsTh
	          .filter(f => f.sortable)
	          .map(f => { return { text: f.label, value: f.key } })
	      }
			},
	    methods: {
				rowClicked(row) {
				  	localStorage.rolesPage = this.currentPage;
        		localStorage.setItem('xyz', row.id)
        		this.$router.push('/role/' + row.id + '/')
      	},
	    	onFiltered (filteredItems) {
		    	// Trigger pagination to update the number of buttons/pages due to filtering
					this.currentPage = parseInt(localStorage.rolesPage)
		    	this.totalRows = filteredItems.length
		    	this.currentPage = 1
		    },
		    resetModal () {
		        this.modalInfo.title = ''
		        this.modalInfo.content = ''
				},
				hideNewLocationModal() {
					this.$refs.newLocationModal.hide()
				},
				showNewLocationModal() {
					this.model = { id : null, name : ''	}
					this.savebtn=false
					this.newLocations = true
				},
      	saveLocations () {
					this.savebtn=true
        	if (this.model.name != null ) {
						roles_service.save(this.model.name)
            	.then(data => {
              	this.$swal(data[0], data[1], data[0])
              	if (data[0] == 'success') {
                	this.newLocations = false
                	this.model = {}
                	this.getAll()
              	}
            	})
            	.catch(error => {
              	this.$swal('Error', 'Server not response. ' + error, 'error')
            	})
        	} else {
							this.$swal('Alert!', 'Data Required', 'warning')
        	}
					this.savebtn=false
      	},
      getAll () {
        this.loadingData = true
        roles_service.getAll()
          .then(data => {
                if (data[0] == 'success') {
									this.items = data[1]
                } else {
                  this.items = []
                  this.$swal(data[0], data[1], data[0])
                }
                this.loadingData = false
          })
          .catch(error => {
            this.$swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      }
	    }
	}
</script>



// WEBPACK FOOTER //
// src/views/roles/m_roles.vue